import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "components/Card";
import Input from "components/Form/Input";
import PageTitle from "components/Title/Page";
import axios from "axios";
import _ from "lodash";
import SpinnerMedium from "components/Spinner/Medium";
import ComboBox from "components/Form/Combobox";
import Button from "components/Form/Button";
import { useNavigate } from "react-router-dom";
import Textarea from "components/Form/Textarea";
import EmptyForm from "components/Form/Empty";
import SingleImageUploader from "components/Form/Input/Image/SingleUploader";
import MultiBadgeCombo from "components/Form/MultiBadgeCombo";
import { useModal } from "components/Modal/Simple";
import FileUploadingSpinner from "common/components/FileUploadingSpinner";
import { PublicApis } from "common/apis/public";

const DoctorEditForm = ({ doctorInfo, onSave = async (formData) => { }, hideClinic = false, hideId = false }) => {
    const [selectedClinicItem, setSelectedClinicItem] = useState(null);
    const [specialtiyItems, setSpecialtyItems] = useState([]);
    const [clinics, setClinics] = useState([]);
    const [formData, setFormData] = useState(null);
    const { Modal: UploadingModal, openModal: openUploadingModal, closeModal: closeUploadingModal } = useModal();
    const navigate = useNavigate();

    useEffect(() => {
        fetchSpecialties();
        if (!hideClinic) {
            fetchClinics();
        }
    }, [])

    useEffect(() => {
        if (_.isNil(doctorInfo)) {
            return;
        }
        setFormData({ ...doctorInfo })
    }, [doctorInfo])

    const fetchSpecialties = async () => {
        const ret = await PublicApis.getSpecialties();
        setSpecialtyItems(ret.data);
    }

    const fetchClinics = async () => {
        const ret = await PublicApis.getClinics();
        console.log("[DoctorEditForm] fetchClinics", ret);
        setClinics(ret.data);
    }

    const handleSave = async () => {
        openUploadingModal();
        await onSave(formData);
        closeUploadingModal();
    }

    if (_.isNil(doctorInfo) || _.isNil(formData)) {
        return <SpinnerMedium />
    }

    console.log("!!! CLINICS", clinics)

    return (
        <Card>
            <div className="p-3 flex flex-col space-y-2">
                <PageTitle>의사 정보 수정</PageTitle>
                {!hideId && (
                    <div>
                        <div className="font-semibold">
                            의사 ID
                        </div>
                        <Input
                            value={doctorInfo.id}
                            disabled={true}
                        />
                    </div>
                )}
                <div>
                    <div className="font-semibold">
                        의사명
                    </div>
                    <Input
                        value={formData.name}
                        onChange={(value) => setFormData({ ...formData, name: value })}
                    />
                </div>
                <div>
                    <div className="font-semibold">
                        소개
                    </div>
                    <Textarea
                        value={formData.description}
                        onChange={(value) => setFormData({ ...formData, description: value })}
                        resizable={true}
                        minRows={5}
                    />
                </div>
                {!hideClinic && !_.isNil(clinics) && (
                    <div>
                        <div className="font-semibold">
                            소속 의원
                        </div>
                        <ComboBox
                            items={clinics}
                            selectedItem={formData.clinic}
                            onChange={(item) => { setSelectedClinicItem(item); setFormData({ ...formData, clinic: item }) }}
                        />
                    </div>
                )}
                <div>
                    <div className="font-semibold">
                        프로필 이미지
                    </div>
                    <EmptyForm>
                        <SingleImageUploader
                            file={formData.profileImage}
                            onFileSelected={(file) => setFormData({ ...formData, profileImage: file })}
                            onFileChanged={(file) => setFormData({ ...formData, profileImage: file })}
                        />
                    </EmptyForm>
                </div>
                <div>
                    <div className="font-semibold">
                        진료과목
                    </div>
                    <EmptyForm>
                        <div className="p-2">
                            <MultiBadgeCombo
                                items={specialtiyItems}
                                selectedItems={formData?.specialties}
                                onSelectedItemsChange={(items) => {
                                    console.log("[ClinicEditPage] onSelectedItemsChange", items);
                                    setFormData({
                                        ...formData,
                                        specialties: items
                                    })
                                }}
                            />
                        </div>
                    </EmptyForm>
                </div>
                <div className="border-t border-gray-300"></div>
                <div>
                    <div className="flex justify-between space-x-2">
                        <div>
                            <Button
                                onButtonClicked={() => { navigate("/main/doctor") }}
                            >
                                목록
                            </Button>
                        </div>
                        <div className="flex space-x-2">
                            <div>
                                <Button
                                    onButtonClicked={() => {
                                        const tempDoctorInfo = {
                                            ..._.omit(formData, ["specialtyIds", "clinicId"]),
                                            clinic: selectedClinicItem,
                                            specialties: formData.specialties,
                                            reviews: doctorInfo.reviews
                                        }
                                        window.localStorage.setItem("tempDoctorInfo", JSON.stringify(tempDoctorInfo));
                                        window.open(`/preview/doctor/pv`, "_blank");
                                    }}
                                >
                                    미리보기
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onButtonClicked={handleSave}
                                >
                                    저장
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <UploadingModal>
                <FileUploadingSpinner />
            </UploadingModal>
        </Card>
    )
}

export default DoctorEditForm;
